import React from 'react';
import { toast, ToastOptions } from 'react-toastify';

import Toast, { ToastProps } from './index';

type ShowSuccessToastOptions = Pick<ToastOptions, 'autoClose'> & {
  layout?: ToastProps['layout'];
};

type ToastContentProps = Pick<ToastProps, 'title' | 'message' | 'layout'> & {
  closeToast?: () => void;
};

const ToastContent = ({
  title,
  message,
  layout,
  closeToast,
}: ToastContentProps): JSX.Element => (
  <Toast
    title={title}
    message={message}
    layout={layout}
    onClose={closeToast}
  />
);

export const showSuccessToast = (
  title: string,
  message: string,
  options?: ShowSuccessToastOptions
): void => {
  toast(
    <ToastContent title={title} message={message} layout={options?.layout} />,
    {
      className: 'ds-toast',
      bodyClassName: 'ds-toast-body',
      progressClassName: 'ds-toast-progress',
      closeButton: false,
      hideProgressBar: true,
      autoClose: options?.autoClose ?? 10000,
    }
  );
};
